<template>
  <div class="v-list">
    <div v-for="(title, ix) in titles" :key="ix" :class="{active: isActive(ix), pointer: !isActive(ix)}" class="" @click="onActive(ix)">
      {{title}}
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'VerticalList',
  components: {},
  props: ['titles', 'active'],
  data: () => ({
    TAG: 'VerticalList :'
  }),
  methods: {
    isActive (index) {
      return this.active === index
    },
    onActive (index) {
      if (this.active !== index) {
        this.$emit('select-item', index)
      }
    }
  }
}
</script>
